import { render, staticRenderFns } from "./delete-user-form.vue?vue&type=template&id=6b3d823b&scoped=true&"
import script from "./delete-user-form.vue?vue&type=script&lang=js&"
export * from "./delete-user-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3d823b",
  null
  
)

export default component.exports